export default "__VITE_ASSET__Bno$NyzQ__"